import { useState } from "react";
import { Copy, Check, MessageCircle, RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function SettingsCodeAccess({ codeAcces, boutiqueName, onRegenerate }) {
  const [codeCopied, setCodeCopied] = useState(false);
  const [showRegenConfirm, setShowRegenConfirm] = useState(false);
  const [regenerating, setRegenerating] = useState(false);

  if (!codeAcces) return null;

  const copyCode = () => {
    navigator.clipboard.writeText(codeAcces);
    setCodeCopied(true);
    toast.success("Code copie !");
    setTimeout(() => setCodeCopied(false), 2000);
  };

  const shareWhatsApp = () => {
    const msg = `Bonjour !\nPour acceder a ma boutique ${boutiqueName} en ligne :\n1. Allez sur ${window.location.origin}\n2. Cliquez "Je suis une cliente"\n3. Entrez le code : ${codeAcces}\nBonne visite !`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const handleRegenerate = async () => {
    setRegenerating(true);
    await onRegenerate();
    setRegenerating(false);
    setShowRegenConfirm(false);
  };

  return (
    <div className="s-card" data-testid="code-cliente-block">
      <div className="s-card-header">
        <div className="s-card-title-row">
          <span style={{ fontSize: '16px' }}>&#128273;</span>
          <h2 className="s-card-title">Code d'acces clientes</h2>
        </div>
      </div>
      <p className="s-card-subtitle">Partagez ce code avec vos clientes</p>

      <div className="s-code-pill" data-testid="code-display">
        {codeAcces.split('').map((c, i) => <span key={i}>{c}</span>)}
      </div>

      <div className="s-code-actions">
        <button className="s-outlined-btn" onClick={copyCode} data-testid="copy-code-btn">
          {codeCopied ? <Check size={14} /> : <Copy size={14} />}
          {codeCopied ? "Copie !" : "Copier le code"}
        </button>
        <button className="s-whatsapp-btn" onClick={shareWhatsApp} data-testid="share-whatsapp-btn">
          <MessageCircle size={14} /> Partager WhatsApp
        </button>
      </div>
      <div className="s-regen-row">
        {!showRegenConfirm ? (
          <button className="s-text-btn" onClick={() => setShowRegenConfirm(true)} data-testid="regenerate-code-btn">
            <RefreshCw size={12} /> Regenerer
          </button>
        ) : (
          <div className="s-regen-confirm">
            <p>Regenerer le code ? L'ancien ne fonctionnera plus.</p>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
              <button className="s-text-btn" onClick={() => setShowRegenConfirm(false)}>Annuler</button>
              <button className="s-text-btn danger" onClick={handleRegenerate} disabled={regenerating}>
                {regenerating ? <Loader2 size={12} className="animate-spin" /> : "Regenerer"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
